<template>
  <Form ref="form" as="div">
    <div>
      <div v-cloak id="memberinfoform">
        <h2 v-html="memberInfoViewModel.HeadingLabel" />
        <div class="row medium-unstack">
          <div class="columns">
            <label
              data-test-memberinfo-label="member-number"
              v-html="memberInfoViewModel.MemberNumberLabel"
            />
            <tooltip :content="memberInfoViewModel.MemberNumberTooltip" />
          </div>
          <div class="columns">
            <p
              data-test-memberinfo-value="member-number"
              v-html="memberInfoViewModel.MemberNumber"
            />
          </div>
        </div>

        <div class="row medium-unstack">
          <div class="columns">
            <label v-html="memberInfoViewModel.MemberNameLabel" />
            <tooltip :content="memberInfoViewModel.MemberNameTooltip" />
          </div>
          <div class="columns">
            <p v-html="memberInfoViewModel.FullName" />
          </div>
        </div>

        <div class="row medium-unstack">
          <div class="columns">
            <label v-html="memberInfoViewModel.MemberAddressLabel" />
            <tooltip :content="memberInfoViewModel.MemberAddressTooltip" />
          </div>
          <div class="columns">
            <p>
              <span
                v-for="(addressLine, index) in memberInfoViewModel.Address"
                :key="'addressline-' + index"
                >{{ addressLine }}<br />
              </span>
            </p>
          </div>
        </div>

        <p
          v-if="memberInfoViewModel.HasProtectedAddress"
          class="help-text"
          v-html="memberInfoViewModel.ProtectedAddressCommentTextLabel"
        />
        <div class="row medium-unstack">
          <div class="columns">
            <label v-html="memberInfoViewModel.MemberCprLabel" />
            <tooltip :content="memberInfoViewModel.MemberCprTooltip" />
          </div>
          <div class="columns">
            <p v-html="memberInfoViewModel.CPR" />
          </div>
        </div>

        <div class="row medium-unstack">
          <div class="columns">
            <label v-html="memberInfoViewModel.MemberPhoneLabel" />
            <tooltip :content="memberInfoViewModel.MemberPhoneTooltip" />
          </div>
          <div class="columns">
            <p
              v-if="!vueModel.phoneNumber.editing"
              class="editable"
              data-clickcategory="minside"
              data-clickaction="click-mine oplysninger"
              data-clicklabel="rediger telefon"
              @click="
                edit(vueModel.phoneNumber);
                cancel(vueModel.email);
              "
            >
              {{ vueModel.phoneNumber.value }}
            </p>
            <Field
              v-if="vueModel.phoneNumber.editing"
              v-cloak
              v-model="vueModel.phoneNumber.value"
              :rules="'required|numeric|min: 8'"
              type="tel"
              name="phoneNumber"
              label="Telefonnummer"
              maxlength="8"
              :disabled="vueModel.phoneNumber.pending"
              data-vv-validate-on="blur"
              @update:modelValue="validateField('phoneNumber', $refs.form)"
            />
            <ValidationError name="phoneNumber" />
          </div>
        </div>

        <div v-if="vueModel.phoneNumber.editing" class="row medium-unstack">
          <div class="columns">
            <button
              class="button secondary"
              :disabled="vueModel.phoneNumber.pending"
              @click="cancel(vueModel.phoneNumber)"
              v-html="memberInfoViewModel.CancelButtonLabel"
            />
          </div>
          <div class="columns">
            <button
              type="reset"
              class="button"
              :disabled="vueModel.phoneNumber.pending || phoneEditSaveDisabled"
              @click="save(vueModel.phoneNumber)"
            >
              {{ saveButtonLabel }}
              <div v-show="vueModel.phoneNumber.pending" class="spinner spinner-button" />
            </button>
          </div>
        </div>

        <div class="row medium-unstack">
          <div class="columns">
            <label v-html="memberInfoViewModel.MemberEmailLabel" />
            <tooltip :content="memberInfoViewModel.MemberEmailTooltip" />
          </div>
          <div class="columns">
            <p
              v-if="!vueModel.email.editing"
              class="editable"
              data-clickcategory="minside"
              data-clickaction="click-mine oplysninger"
              data-clicklabel="rediger email"
              @click="
                edit(vueModel.email);
                cancel(vueModel.phoneNumber);
              "
            >
              {{ vueModel.email.value }}
            </p>
            <Field
              v-if="vueModel.email.editing"
              v-cloak
              v-model="vueModel.email.value"
              :rules="'required|email'"
              type="email"
              name="email"
              label="E-mail"
              :disabled="vueModel.email.pending"
              data-vv-validate-on="blur"
              @update:modelValue="validateField('email', $refs.form)"
            />
            <ValidationError name="email" />
          </div>
        </div>

        <div v-if="vueModel.email.editing" class="row medium-unstack">
          <div class="columns">
            <button
              class="button secondary"
              :disabled="vueModel.email.pending"
              @click="cancel(vueModel.email)"
              v-html="memberInfoViewModel.CancelButtonLabel"
            />
          </div>
          <div class="columns">
            <button
              id="save-email-btn"
              class="button"
              :disabled="vueModel.email.pending || emailEditSaveDisabled"
              @click="save(vueModel.email)"
            >
              {{ saveButtonLabel }}
              <div v-show="vueModel.email.pending" class="spinner spinner-button" />
            </button>
          </div>
        </div>

        <div v-if="memberInfoViewModel.IsStudent">
          <div class="row medium-unstack">
            <div class="columns">
              <label v-html="memberInfoViewModel.MemberStudentLabel" />
              <tooltip :content="memberInfoViewModel.MemberStudentTooltip" />
            </div>
            <div class="columns">
              <p v-if="!vueModel.editingStudentEndDate">
                <span v-html="memberInfoViewModel.IsStudentTextValueLabel" />
                <span
                  id="studentPeriod"
                  v-html="'&nbsp;' + memberInfoViewModel.StudentUntilFormatted"
                />
              </p>
              <date-picker
                v-if="vueModel.editingStudentEndDate"
                :id="'mypicker'"
                :date="vueModel.studentEndDate"
                class="datepicker"
                @date-changed="dateChanged"
              />
            </div>
          </div>

          <div v-if="vueModel.editingStudentEndDate" class="row medium-unstack">
            <div class="columns">
              <button
                class="button secondary"
                @click="vueModel.editingStudentEndDate = false"
                v-html="memberInfoViewModel.CancelButtonLabel"
              />
            </div>
            <div class="columns">
              <button
                class="button"
                @click="saveEmail"
                v-html="memberInfoViewModel.SaveButtonLabel"
              />
            </div>
          </div>
        </div>

        <div
          v-if="
            memberInfoViewModel.ShowConsentEditLink &&
            !memberInfoViewModel.IsCorporationMember &&
            isMemberValidConsentGiver
          "
          data-test-member-cpr-consent-block="cpr-consent-block"
          class="row medium-unstack"
        >
          <div class="columns">
            <label v-html="memberInfoViewModel.MemberCprConsentLabel" />
            <tooltip :content="memberInfoViewModel.MemberCprConsentTooltip" />
          </div>
          <div
            class="columns"
            data-clickcategory="minside"
            data-clickaction="click-mine oplysninger"
            data-clicklabel="rediger samtykke"
          >
            <p
              data-test-member-cpr-consent="cpr-consent"
              :class="{ editable: memberInfoViewModel.UserTypeEnum === 1 }"
              @click="showCprModal()"
            >
              {{ hasGivenCprConsentValue }}
            </p>
          </div>
        </div>
      </div>

      <div v-if="editMode" class="row medium-unstack">
        <div class="columns" v-html="memberInfoViewModel.PersonalPermissionUrl" />
      </div>
    </div>
  </Form>
</template>

<script>
import axios from 'axios';
import BaseMixin from '@/components/Feature/BaseMixin.vue';
import ValidatePropsMixin from '@/components/Feature/ValidatePropsMixin.vue';
import pickadate from '@/components/UI/Pickadate.vue';
import Tooltip from '@/components/UI/Tooltip.vue';
import UtilityFunctions from '@/common/UtilityFunctions.js';
import ValidationError from '@/components/UI/ValidationError.vue';

export default {
  name: 'MemberInfo',
  components: {
    'date-picker': pickadate,
    Tooltip,
    ValidationError
  },
  mixins: [BaseMixin, ValidatePropsMixin],
  props: {
    memberInfoViewModel: {
      type: Object,
      default() {
        return null;
      }
    }
  },
  data() {
    return {
      vueModel: {
        phoneNumber: {
          fieldName: 'phoneNumber',
          value: this.memberInfoViewModel.Phone,
          currentSavedValue: this.memberInfoViewModel.Phone,
          url: '/api/member/updatephone',
          data: 'phonenumber',
          phoneId: this.memberInfoViewModel.PhoneId,
          editing: false,
          pending: false
        },
        email: {
          fieldName: 'email',
          value: this.memberInfoViewModel.Email,
          currentSavedValue: this.memberInfoViewModel.Email,
          url: '/api/member/updateemail',
          data: 'emailaddress',
          emailId: this.memberInfoViewModel.EmailId,
          editing: false,
          pending: false
        },
        editingStudentEndDate: false,
        studentEndDate: '2022-01-22T00:00:00+01:00',
        studentEndDateFormatted: '22. januar 2022'
      }
    };
  },
  computed: {
    editMode() {
      // return !jQuery.isEmptyObject(this.fields);
    },
    phoneEditSaveDisabled() {
      let returnValue =
        this.vueModel.phoneNumber.value === this.vueModel.phoneNumber.currentSavedValue ||
        this.vueModel.phoneNumber.value.length !== 8;
      return returnValue;
    },
    emailEditSaveDisabled() {
      let validEmail = UtilityFunctions.validEmail(this.vueModel.email.value);
      let returnValue =
        this.vueModel.email.value === this.vueModel.email.currentSavedValue ||
        this.vueModel.email.value.length === 0 ||
        !validEmail;
      return returnValue;
    },
    hasGivenCprConsentValue() {
      if (this.memberInfoViewModel.HasGivenCPRConsent) {
        return this.memberInfoViewModel.ConsentAcceptedText;
      }

      if (this.memberInfoViewModel.HasGivenCPRConsent === false) {
        return this.memberInfoViewModel.ConsentDeclinedText;
      }

      return '';
    },
    isMemberValidConsentGiver() {
      if (
        this.memberInfoViewModel.IsPolicyHolder ||
        this.memberInfoViewModel.IsNonPolicyHolderWithProposals
      )
        return true;

      return false;
    },
    saveButtonLabel() {
      return UtilityFunctions.decodeHtml(this.memberInfoViewModel.SaveButtonLabel);
    }
  },
  methods: {
    edit(prop) {
      this.$refs.form.setErrors({});
      this.vueModel.phoneNumber.editing = false;
      this.vueModel.email.editing = false;
      prop.editing = true;
    },
    save(prop) {
      this.$refs.form.validate().then((result) => {
        if (result) {
          prop.pending = true;

          const data = {
            [prop.data]: prop.value
          };
          if (prop.phoneId) {
            data.PhoneId = prop.phoneId;
          }
          if (prop.emailId) {
            data.EmailId = prop.emailId;
          }

          const $field = $(`input[name='${prop.fieldName}']`);

          axios
            .post(prop.url, data)
            .then((response) => {
              const resp = response.data;
              if (!resp.IsSuccess) {
                let errors = {};
                errors[prop.fieldName] =
                  `${$field.attr('label')} kunne ikke opdateres på grund af systemfejl.`;
                this.$refs.form.setErrors({
                  errors
                });

                prop.value = prop.currentSavedValue;
              } else {
                prop.currentSavedValue = prop.value;
                prop.editing = false;
                if (prop.phoneId !== undefined) {
                  prop.phoneId = resp.ID;
                }
                if (prop.emailId !== undefined) {
                  prop.emailId = resp.ID;
                }
              }
              prop.pending = false;
            })
            .catch(() => {
              let errors = {};
              errors[prop.fieldName] = `${$field.attr('label')} kunne ikke gemmes`;
              this.$refs.form.setErrors({
                errors
              });

              prop.value = prop.currentSavedValue;
              prop.editing = false;
              prop.pending = false;
            });
        }
      });
    },
    cancel(prop) {
      this.$refs.form.setErrors({});
      prop.editing = false;
      prop.value = prop.currentSavedValue;
    },
    dateChanged(param) {
      this.studentEndDate = param.format();
      this.studentEndDateFormatted = param.format('LL');
    },
    showCprModal() {
      if (this.memberInfoViewModel.UserTypeEnum !== 1) {
        return false;
      }

      this.$store.dispatch('cprConsent/openModalByClickOnMemberInfo', true);
      this.$store.dispatch('Events/register', {
        event: 'cpr-consent-modal-edit',
        id: 'cprConsentModal',
        vm: this
      });
    }
  }
};
</script>
